export enum SlotBulkActions {
  EditTotalCapacity = 'capacity',
  OpenSlot = 'open',
  CloseSlot = 'close',
}
